import React from 'react';
import PropTypes from 'prop-types';

import { Group } from 'components/core/Page';
import { Text } from 'components/core/Typography';
import { Image } from 'components/core/Image';
import { GhostFacilityCard } from 'components/search/GhostFacilityCard';
import { FacilityPromoCard } from 'components/search/FacilityPromoCard';

import arrowIcon from 'assets/images/icons/icon-arrow.svg';

import './TopPromoCards.scss';

export default function TopPromoCards({
	facilities, promoFacilitiesCount, fmfBadgeMessage
}) {
	return (
		<div className="top-promo-cards">
			<div className="top-promo-container">
				{(!!promoFacilitiesCount && fmfBadgeMessage) &&
					<div className="top-cards-header">
						<Text className="head-message">
							<Image
								src={arrowIcon}
								alt="arrow icon"
								className="arrow-icon"							
							/>
							Facilities with this badge offer first month free!
						</Text>
					</div>
				}
				<Group className="top-cards-group">
					{facilities.map(({
						name, url, images, distance, reviews, hasFmf, isGhost
					}) => (
						(isGhost) ?
							<GhostFacilityCard key={name} /> :
							<FacilityPromoCard
								name={name}
								url={url.facility}
								image={(images.length && images.length > 1) ? images[1] : images[0] || null}
								distance={distance}
								reviews={reviews}
								hasFmf={hasFmf}
								key={name}
							/>
					))}
				</Group>
			</div>
		</div>
	);
}

TopPromoCards.propTypes = {
	facilities: PropTypes.arrayOf(PropTypes.object),
	promoFacilitiesCount: PropTypes.number,
	fmfBadgeMessage: PropTypes.bool
};
